import {initializeApp, getApps} from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyBdlDHfXnaAoOY98jf7XS-nYFJX0sqXFEs',
  authDomain: 'respondermap.firebaseapp.com',
  projectId: 'respondermap',
  storageBucket: 'respondermap.firebasestorage.app',
  messagingSenderId: '786639569151',
  appId: '1:786639569151:web:6c77fd6eb226890fb98cca',
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export default app;
